import axios from "axios";
import { toast } from "react-toastify";
import { API_BASE_PATH } from "../environment";

const BASE_URL = `${API_BASE_PATH}/knowlarity`;

export interface CallLog {
  id: number;
  order_id: number;
  customer_number: string;
  uuid: string;
  agent_number: string;
  call_duration: number;
  business_call_type: string;
  destination: string;
  Call_Type: number;
  call_recording: string;
  knowlarity_number: string;
  start_time: string;
  credits_deducted: string;
  extension: string;
  caller_name: string;
  timezone_offset: string;
  company_phone: string;
  agent_name: string;
  agent_status: string;
  customer_status: string;
  solution: string;
  company_name: string;
  call_status: string;
  date_time: string;
  sr_number: string;
  customer: string;
  agent: string;
  total_call_duration: string;
  talk_time: string;
  call_actions: string;
  call_uuid: string;
}

export interface Recording {
  recording_url: string;
  call_id: string;
  timestamp: string;
}

export interface CallLogsResponse {
  total: number;
  data: CallLog[];
}

export interface WebhookResponse {
  status: string;
  message: string;
}

const getAuthHeaders = () => {
  const token = localStorage.getItem("authToken") || "";
  return {
    Authorization: token,
    Accept: "application/json",
  };
};

const showAxiosError = (error: any, fallback: string) => {
  const detail = error?.response?.data?.detail || error?.message || fallback;
  if (Array.isArray(detail)) {
    detail.forEach((err: any) => toast.error(err.msg));
  } else {
    toast.error(detail);
  }
};

// ✅ POST: Make a call to a lead
export const makeCallToLead = async (
  lead_id?: string | null,
  customer_number?: string | null
): Promise<string> => {
  try {
    const body: { lead_id?: string; customer_number?: string } = {};
    if (lead_id) body.lead_id = lead_id;
    if (customer_number) body.customer_number = customer_number;

    const response = await axios.post(`${BASE_URL}/call/lead`, body, {
      headers: {
        ...getAuthHeaders(),
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    toast.success(response.data || "Call initiated");
    return response.data;
  } catch (error) {
    showAxiosError(error, "Failed to make call");
    throw error;
  }
};

// ✅ GET: All call logs
export const getAllCallLogs = async (
  params?: any
): Promise<CallLogsResponse> => {
  try {
    const response = await axios.get(`${BASE_URL}/all-call-logs`, {
      headers: getAuthHeaders(),
      params,
    });
    return {
      total: response.data.total || 0,
      data: response.data.data || [],
    };
  } catch (error) {
    showAxiosError(error, "Failed to fetch call logs");
    throw error;
  }
};

// ✅ GET: Call recording by call_id
export const getRecordingByCallId = async (
  call_id: string
): Promise<string> => {
  try {
    const response = await axios.get(`${BASE_URL}/recording/${call_id}`, {
      headers: getAuthHeaders(),
    });
    return response.data || "";
  } catch (error) {
    showAxiosError(error, "Failed to fetch recording");
    throw error;
  }
};

// ✅ POST: Trigger webhook manually
export const triggerWebhook = async (): Promise<WebhookResponse> => {
  try {
    const response = await axios.post(`${BASE_URL}/webhook`, null, {
      headers: getAuthHeaders(),
    });
    toast.info(response.data.message || "Webhook triggered");
    return response.data;
  } catch (error) {
    showAxiosError(error, "Webhook failed");
    throw error;
  }
};
